const Home = () => {
  return (
    <div>
      <h3>Home</h3>
      <p>Bienvenid@s al tema de las Rutas en React</p>
    </div>
  );
};

export default Home;
